<!-- results-table.component.html -->
<h1 mat-dialog-title><strong>Modificar</strong> contraseña</h1>
<div mat-dialog-content >
  <div fxLayout="column">
    <mat-form-field class="select-full" fxFlex="100">
      <input type="password" placeholder="Contraseña actual" matInput [(ngModel)]="LOCAL_DATA.pswAnterior" >
    </mat-form-field>
    <mat-form-field class="select-medio" fxFlex="100">
      <input type="password" placeholder="Nueva contraseña (Mínimo 8 caractéres)" matInput [(ngModel)]="LOCAL_DATA.pswNuevo" >
    </mat-form-field>
    <mat-form-field fxFlex="100">
      <input type="password" placeholder="Repetir nueva contraseña (Mínimo 8 caractéres)" matInput [(ngModel)]="LOCAL_DATA.pswConfirm">
    </mat-form-field>
  </div>
</div>
<div mat-dialog-actions >
  <button mat-button (click)="doAction()" [disabled]="LOCAL_DATA.pswAnterior=='' || LOCAL_DATA.pswNuevo=='' ||  LOCAL_DATA.pswConfirm!=LOCAL_DATA.pswNuevo ">{{'Update' | translate}}</button>
  <button mat-button (click)="closeDialog()" mat-flat-button color="warn">{{'Cancel' | translate}}</button>
</div>
